import { createFileRoute, redirect } from "@tanstack/react-router"

// Legacy full-page form record. The form record is now a nested column under
// /forms/$formId (with `?focus=1` for the single-column "fullscreen" feel).
// Keep this segment as a redirect so old links / bookmarks resolve.
export const Route = createFileRoute("/$orgSlug/$eventSlug/f/$formId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$orgSlug/$eventSlug/forms/$formId",
      params,
      search: { focus: 2 },
    })
  },
})
